import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { getClientTz } from '../../../../utils/date';
import { analyticsClient } from '../../../../services';
import dayjs, { toUTCDateTimeFormat } from '~/utils/dayjs';

export const useContactsTotalCreated = createGlobalState(() => {
    const error = ref(false);
    const loading = ref(false);

    const data = ref([]);

    const clearData = () => {
        error.value = false;
        data.value = [];
    };

    const calculateRange = ({ startDate, endDate }) => {
        const dates = [];
        const startDayjs = dayjs(startDate).tz(getClientTz());
        const endDayjs = dayjs(endDate).tz(getClientTz());

        let currentDate = startDayjs.clone();

        // first point
        dates.push(toUTCDateTimeFormat(currentDate));

        // remaining points
        while (currentDate.unix() < endDayjs.unix()) {
            currentDate = currentDate.add(1, 'day');
            dates.push(toUTCDateTimeFormat(currentDate));
        }

        // move last point back
        dates[dates.length - 1] = toUTCDateTimeFormat(dayjs(endDate));

        return dates;
    };

    const lookupData = () => {
        return new Promise((resolve) => {
            if (!loading.value) {
                resolve(data.value);
                return;
            }
            setTimeout(() => {
                resolve(lookupData());
            }, 500);
        });
    };

    const fetchData = async ({ startDate, endDate } = {}) => {
        if (loading.value) {
            return await lookupData();
        }
        const params = {
            range: calculateRange({ startDate, endDate }),
        };

        clearData();
        loading.value = true;
        try {
            const res = await analyticsClient.contactsTotalCreated(Spark.state.currentTeam.id, params);

            if (!res.data?.time_range?.length || !res.data?.values?.length) {
                return [];
            }

            data.value = res.data.time_range.map((date, index) => {
                const value = res.data.values[index] || 0;
                return {
                    label: date,
                    count: value,
                    tooltip: `${dayjs.utc(date).tz(getClientTz()).format('MM/DD')}: ${Intl.NumberFormat('en').format(
                        value
                    )}`,
                    iconColor: '#14ABE0',
                    bgColor: '#73D8FC',
                };
            });

            data.value.pop();
            return data.value;
        } catch (e) {
            error.value = true;
            console.error(e);
        } finally {
            loading.value = false;
        }
    };

    return {
        loading,
        error,
        data,
        fetchData,
    };
});
